import { Action } from '@ngrx/store';

export enum VerifierActionTypes {
    Set = '[Verifier] Set',
    Unset = '[Verifier] Unset'
}

export class SetVerifier implements Action {
    readonly type: VerifierActionTypes.Set = VerifierActionTypes.Set;
    constructor(public payload: string) {}
}

export class UnsetVerifier implements Action {
    readonly type: VerifierActionTypes.Unset = VerifierActionTypes.Unset;
}

export type VerifierActions = SetVerifier | UnsetVerifier;
